<template>
  <div class="chatbox-title">
    <div class="icon-holder">
      <slot name="left"></slot>
    </div>
    <div class="title-holder">
      <slot name="center"></slot>
    </div>
    <!-- <span>
      <a class="title-link" target="_blank" :href="`https://yoteachapp.com/room/${roomID}`">{{ title }}</a>
    </span> -->
    <div class="icon-holder">
      <slot name="right"></slot>
    </div>
  </div>
</template>

<script>
export default {
}
</script>

<style scoped>
.chatbox-title{
  padding: 15px;
  font-size: 16px;
  line-height: 1;
  background-image: linear-gradient(-90deg, #a71524, hsl(0, 83%, 41%), #f73c3c);
  /* background-image: linear-gradient(45deg, rgb(25, 88, 111), rgb(108, 143, 154)); */
  /* background-image: linear-gradient(0deg, rgb(166, 11, 38), rgb(204,0,0)); */
  /* background-color: rgb(204, 0, 0); */
  /* border-radius: 20px 20px 0px 0px; */
  color: white;
  text-align: center;
  border-bottom: #cccccc solid 1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.icon-holder{
  height: 24px;
}
.title-holder{
  max-width: 200px;
}
@media screen and (min-width: 767px) {
  .title-holder{
    max-width: 767px;
  }
}
</style>
